import React from 'react';
import PropTypes from 'prop-types';

import { gql } from '@nerdwallet/apollo';
import { Box, Title } from '@nerdwallet/currency';

import ArticleStructuredContent from '../article-structured-content/article-structured-content';
import { BlockFragment } from '~/generated-gql/generated-types';

interface Props {
  block?: BlockFragment;
}

const Block: React.GraphqlFC<Props> = ({ block }) => {
  if (!block || !block?.data) {
    return null;
  }

  const { title, data: structuredData } = block;

  return (
    <Box>
      {title && <Title size="small">{title}</Title>}
      <ArticleStructuredContent>{structuredData}</ArticleStructuredContent>
    </Box>
  );
};

Block.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  block: PropTypes.object.isRequired,
};

Block.fragment = gql`
  fragment block on CombinedBlockGroupBlock {
    type
    title
    data
  }
`;

export default Block;
